/**
 * Даты доступа — по московскому времени, независимо от часового пояса
 * браузера. Тот же пояс, что у счётчика подарочных дней (backend/gift_days.py):
 * регистрация 15.10 в 22:30 МСК даёт «до 29.10» и в Москве, и в Новосибирске,
 * а не «до 30.10» у того, чей браузер в UTC+7.
 */
const MSK = 'Europe/Moscow';

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/** {day, month, year} даты в МСК (числа). */
export function mskParts(value) {
  const d = toDate(value);
  if (!d) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: MSK, day: '2-digit', month: '2-digit', year: 'numeric',
  }).formatToParts(d);
  const get = (t) => Number(parts.find((p) => p.type === t).value);
  return { day: get('day'), month: get('month'), year: get('year') };
}

const pad = (n) => String(n).padStart(2, '0');

/** «29.10.2026» по МСК; пусто — fallback. */
export function formatMskDate(value, fallback = '—') {
  const p = mskParts(value);
  return p ? `${pad(p.day)}.${pad(p.month)}.${p.year}` : fallback;
}

/** «29.10» по МСК, год — только если не текущий (тоже по МСК). */
export function formatMskDateShort(value, now = Date.now()) {
  const p = mskParts(value);
  if (!p) return '';
  const cur = mskParts(now);
  return cur && cur.year === p.year ? `${pad(p.day)}.${pad(p.month)}` : `${pad(p.day)}.${pad(p.month)}.${p.year}`;
}

/** «29.10.2026, 22:30» по МСК — для админки. */
export function formatMskDateTime(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  const t = new Intl.DateTimeFormat('en-GB', { timeZone: MSK, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(d);
  return `${formatMskDate(d)}, ${t}`;
}
